module.exports = __webpack_public_path__ + "static/media/lingshou-2.5d5b9d02.png";